<div class="emission-consult-page">

  <div class="page-intro">
    <b3-breadcrumbs aria-label="Breadcrumb">
      <b3-breadcrumbs-item variant="icon" href="/"></b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Registro de projetos e emissão de créditos</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Emissão de Créditos</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">{{ breadcrumbLeaf }}</b3-breadcrumbs-item>
    </b3-breadcrumbs>
    <h1 class="page-title">{{ pageTitle }}</h1>
  </div>

  <section class="consult-content" aria-label="Consulta de emissões de crédito">
    <div class="consult-toolbar">
      <div class="consult-filters">
        <div class="consult-filters__field consult-filters__field--search">
          <b3-input-search
            [(ngModel)]="searchTermProjName"
            inputId="searchTermProjName"
            label="Nome do Projeto"
            background="grey"
            placeholder="Pesquisar pelo nome do projeto"
            searchAriaLabel="Buscar emissões pelo nome do projeto"
            closeAriaLabel="Limpar busca por nome do projeto"
            (b3-search)="onFilterTable()"
            (b3-clear)="onFilterTable()">
          </b3-input-search>
        </div>

        <div class="consult-filters__field consult-filters__field--search">
          <b3-input-search
            [(ngModel)]="searchTermSerialCode"
            inputId="searchTermSerialCode"
            label="Serial Range"
            background="grey"
            placeholder="Pesquisar pelo serial range da emissão"
            searchAriaLabel="Buscar emissões pelo serial range"
            closeAriaLabel="Limpar busca por serial range"
            (b3-search)="onFilterTable()"
            (b3-clear)="onFilterTable()">
          </b3-input-search>
        </div>

        <div class="consult-filters__field consult-filters__field--status">
          <b3-input-select
            [(ngModel)]="searchStatus"
            inputId="searchStatus"
            label="Status"
            placeholder="Selecione o status"
            background="grey"
            maxHeight="280px"
            [options]="selectedStatus"
            (b3-change)="onFilterTable()">
            <b3-input-select-option
              *ngFor="let item of selectedStatus; let i = index"
              [attr.value]="item.inputId"
              [attr.index]="i"
              [id]="'searchStatus-option-' + item.inputId">
              {{ item.label }}
            </b3-input-select-option>
          </b3-input-select>
        </div>
      </div>

      <div *ngIf="showButtonProjectRegister" class="consult-toolbar__action">
        <span class="consult-toolbar__label-spacer" aria-hidden="true"></span>
        <b3-button
          type="button"
          variant="filled"
          tone="default"
          size="lg"
          class="consult-toolbar__new-btn"
          (b3-click)="navigateToProjectRegister()">
          <b3-icon name="add"></b3-icon>
          Nova Emissão
        </b3-button>
      </div>
    </div>

    <div class="consult-table-section">
      <p class="consult-table-summary" aria-live="polite">{{ emissionsFoundLabel }}</p>

      <div class="consult-table-shell">
        <ng-container *ngIf="itens.length > 0; else emptyTableState">
          <b3-table
            size="sm"
            background="striped"
            aria-label="Lista de emissões de crédito"
            [attr.aria-rowcount]="totalItens"
            aria-colcount="7">
            <b3-table-rowgroup group="header">
              <b3-table-row>
                <b3-table-cell-header label="Nome do Projeto"></b3-table-cell-header>
                <b3-table-cell-header label="Serial Range"></b3-table-cell-header>
                <b3-table-cell-header label="Núm. de Emissão"></b3-table-cell-header>
                <b3-table-cell-header label="Quant. Emitida" align="end"></b3-table-cell-header>
                <b3-table-cell-header label="Data de Emissão"></b3-table-cell-header>
                <b3-table-cell-header label="Status"></b3-table-cell-header>
                <b3-table-cell-header label="Detalhes" align="center"></b3-table-cell-header>
              </b3-table-row>
            </b3-table-rowgroup>

            <b3-table-rowgroup group="body">
              <b3-table-row
                *ngFor="let emission of itens; trackBy: trackByEmissionId"
                [id]="'emission-row-' + emission.id">
                <b3-table-cell variant="text" [label]="emission.projectName || '-'"></b3-table-cell>
                <b3-table-cell variant="slot">
                  @let serialCode = getSerialCode(emission);
                  @if (serialCode) {
                    <b3-tooltip
                      [label]="serialCode"
                      variant="single-line"
                      pointer="top">
                      <span
                        tabindex="0"
                        class="consult-table-serial-range consult-table-serial-range--interactive"
                        [attr.aria-label]="getSerialCodeAriaLabel(emission)"
                        (click)="copySerialCode(emission, $event)"
                        (keydown)="onSerialCodeKeydown(emission, $event)">
                        {{ serialCode }}
                      </span>
                    </b3-tooltip>
                  } @else {
                    <span class="consult-table-serial-range consult-table-serial-range--empty">-</span>
                  }
                </b3-table-cell>
                <b3-table-cell variant="text" [label]="emission.emissionNumber || '-'"></b3-table-cell>
                <b3-table-cell variant="number" [label]="formatQuantity(emission.emissionQuantity)"></b3-table-cell>
                <b3-table-cell variant="text" [label]="emission.insertDate || '-'"></b3-table-cell>
                <b3-table-cell variant="tag">
                  <b3-tag
                    size="sm"
                    variant="filled"
                    [icon]="getStatusIcon(emission.status)"
                    [tone]="getStatusTone(emission.status)"
                    [label]="getStatusLabel(emission.status)">
                  </b3-tag>
                </b3-table-cell>
                <b3-table-cell variant="slot">
                  <div class="consult-table-actions">
                    <b3-button
                      type="button"
                      variant="ghost"
                      tone="default"
                      size="sm"
                      [attr.aria-label]="getEmissionDetailLabel(emission)"
                      (b3-click)="navigateToPageView(emission)">
                      <b3-icon name="visibility"></b3-icon>
                    </b3-button>
                  </div>
                </b3-table-cell>
              </b3-table-row>
            </b3-table-rowgroup>
          </b3-table>
        </ng-container>

        <ng-template #emptyTableState>
          <app-consult-table-empty-state></app-consult-table-empty-state>
        </ng-template>
      </div>

      <div class="consult-table-pagination" *ngIf="totalPages > 1">
        <p class="consult-table-pagination__info">{{ recordsPerPageLabel }}</p>
        <b3-pagination
          aria-label="Paginação de emissões de crédito"
          variant="numbers"
          navigation="icon"
          overflow
          [attr.total]="totalPages"
          [attr.current]="pagination.page ?? 1"
          (b3-change)="onPaginationChange($event)">
        </b3-pagination>
      </div>
    </div>
  </section>

  <footer class="page-footer">
    <p class="page-footer__text">B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.</p>
  </footer>
</div>

<app-emission-consult-details-drawer
  [open]="isDetailsDrawerOpen"
  [emissionId]="selectedEmissionId"
  (openChange)="onDetailsDrawerOpenChange($event)"
  (emissionUpdated)="onEmissionUpdatedInDrawer()">
</app-emission-consult-details-drawer>
